import React, { useRef } from 'react'

import { Account } from '@driftt/api-types'
import { Div } from '@driftt/tide-core'

import Card from 'components/Card'
import { CompanyData } from 'modules/accountActivity/domain'
import GroupedAttributesCard from 'sections/CCRM/GroupedAttributesCard'

import styles from './styles.module.css'

interface AttributesTabProps {
  account: Account | undefined
  company: CompanyData | undefined
  sfdcAccounts: any[] | undefined
}

const scrollToElement = (ref: React.MutableRefObject<HTMLDivElement | null>) => {
  if (ref?.current) {
    ref.current.scrollIntoView({ behavior: 'smooth' })
  }
}

const parseSFDCAccount = (sfdcAccounts: any[] | undefined) => {
  return (
    sfdcAccounts?.[0] && [
      {
        label: 'Account name',
        value: sfdcAccounts[0].Name || '-'
      },
      {
        label: 'Account type',
        value: sfdcAccounts[0].type || '-'
      },
      {
        label: 'Account owner',
        value: sfdcAccounts[0].Owner?.Name || '-'
      }
    ]
  )
}

const NUMERIC_INTEL_FIELDS = ['employeeCount', 'alexaGlobalRank', 'alexaUsRank']
const TEN_THOUSAND_PLUS = '10001'

const AttributesTab: React.FC<AttributesTabProps> = ({ account, company, sfdcAccounts }) => {
  const sfdcAccountDataCard = useRef<HTMLDivElement>(null)
  const customAttributesCard = useRef<HTMLDivElement>(null)
  const driftIntelCompanyCard = useRef<HTMLDivElement>(null)

  const customAttributes = account?.customProperties?.sort() || []
  const intelData =
    company &&
    Object.entries(company)
      .filter(field => field[0] !== 'driftIntelSources')
      .map(field => ({
        label: field[0],
        value: field[1] === TEN_THOUSAND_PLUS ? '10k+' : field[1],
        type: NUMERIC_INTEL_FIELDS.includes(field[0]) ? 'NUMBER' : 'STRING'
      }))

  return (
    <Div className={styles.container}>
      <Card className={styles.quickLinks}>
        <p>JUMP TO</p>
        <button onClick={() => scrollToElement(sfdcAccountDataCard)}>Salesforce Account</button>
        <button onClick={() => scrollToElement(customAttributesCard)}>Custom Properties</button>
        <button onClick={() => scrollToElement(driftIntelCompanyCard)}>Drift Intel Company</button>
      </Card>
      <Div className={styles.mainContent}>
        <GroupedAttributesCard
          headerText="Salesforce Account"
          attributes={parseSFDCAccount(sfdcAccounts)}
          emptyStateText="No matching account in Salesforce"
          forwardRef={sfdcAccountDataCard}
        />
        <GroupedAttributesCard
          headerText="Custom Properties"
          attributes={customAttributes}
          emptyStateText="No custom properties for this account"
          forwardRef={customAttributesCard}
        />
        <GroupedAttributesCard
          headerText="Drift Intel Company"
          attributes={intelData}
          emptyStateText="No Drift Intel for this company"
          forwardRef={driftIntelCompanyCard}
        />
      </Div>
    </Div>
  )
}

export default AttributesTab
